import React from "react";
import "./index.css";
import { Link, redirect, useNavigate } from "react-router-dom";
import { TbFaceIdError } from "react-icons/tb";
import { PrimaryBtn } from "../components/BasicComponents";
import { useTranslation } from "react-i18next";
import "../localisation/index"
const ErrorPage = () => {
  const {t} = useTranslation()
  const navigate = useNavigate();
  return (
    <div className="error-page component">
      <TbFaceIdError className="error-icon" />
      <p className="error-page__msg">
        {t("errorPage.notFound")}
      </p>

      <div>
        <PrimaryBtn
          $primary
          onClick={() => navigate("/home", { replace: true })}
        >
          {t("errorPage.backToHome")}
        </PrimaryBtn>
      </div>
    </div>
  );
};

export default ErrorPage;
